import { useTranslation } from "react-i18next";
import { useRoutes } from "react-router";
import { PrivacyConsent } from "@/components/PrivacyConsent";
import { APP_LOCALE } from "@/constants/index";
import { CookieContextProvider } from "@/context/CookieContext";
import { Cookies } from "@/pages/Legal/components/Cookies";
import { routes } from "@/router";
import { useAppStore } from "@/store/app/slice";
import { ToastContainer } from "@/ui-kit";
import { AuthProvider } from "./pages/Auth";
import { ComponentsLocaleProvider } from "./ui-kit";

const App = () => {
  const { t } = useTranslation();
  const router = useRoutes(routes);
  const showCookiesBanner = useAppStore((s) => s.showCookiesBanner);

  return (
    <ComponentsLocaleProvider language="en" t={t} formatLocale={APP_LOCALE}>
      <CookieContextProvider>
        <AuthProvider>
          <div className="nuco-app">{router}</div>
          <ToastContainer />
          {showCookiesBanner && <Cookies />}
          <PrivacyConsent />
        </AuthProvider>
      </CookieContextProvider>
    </ComponentsLocaleProvider>
  );
};

export default App;
